import { render } from "./statusview.vue?vue&type=template&id=653b3fcf"
import script from "./statusview.vue?vue&type=script&lang=js"
export * from "./statusview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__